import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = <Route path="schools/:id" component={Views.School} />

export default Routes
